// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__28Q52","insightsList":"newBusinessInsightsMenu_insightsList__2HPsa","active":"newBusinessInsightsMenu_active__3ZvsT"};